export default __webpack_public_path__ + "static/amico-06dbfdf5ad118f37322912aede601339.png";